import * as _ from "lodash";
import * as $ from "jquery";
import { Command } from "./command";

import { OpenNewEstimatePopupCommand } from "./commands/openNewEstimatePopupCommand";
import { OpenEstimatesPopupCommand } from "./commands/openEstimatesPopupCommand";
import { OpenCostbooksPopupCommand } from "./commands/openCostbooksPopupCommand";
import { OpenCostbookPropertiesPopupCommand } from "./commands/openCostbookPropertiesPopupCommand";
import { OpenCustomerInfoPopupCommand } from "./commands/openCustomerInfoPopupCommand";
import { OpenCompanyInfoPopupCommand } from "./commands/openCompanyInfoPopupCommand";
import { OpenAccountingSettingsPopupCommand } from "./commands/openAccountingSettingsPopupCommand";
import { OpenDefaultCompanyInfoPopupCommand } from "./commands/openDefaultCompanyInfoPopupCommand";
import { OpenEstimateSettingsPopupCommand } from "./commands/openEstimateSettingsPopupCommand";
import { OpenImportEstimatePopupCommand } from "./commands/openImportEstimatePopupCommand";

import { OpenTaxRatesPopupCommand } from "./commands/openTaxRatesPopupCommand";
import { OpenMarkupsPopupCommand } from "./commands/openMarkupsPopupCommand";
import { OpenPercentagesPopupCommand } from "./commands/openPercentagesPopupCommand";
import { OpenAreaCostsModificationsPopupCommand } from "./commands/openAreaCostsModificationsPopupCommand";
import { OpenEstimateSaveAsPopupCommand } from "./commands/openEstimateSaveAsPopupCommand";
import { OpenEstimateImportPopupCommand } from "./commands/openEstimateImportPopupCommand";
import { OpenEstimateExportPopupCommand } from "./commands/openEstimateExportPopupCommand";
import { CreateEstimateTextRowCommand } from "./commands/createEstimateTextRowCommand";
import { EditEstimateTextRowCommand } from "./commands/editEstimateTextRowCommand";
import { CreateEstimateCostRowCommand } from "./commands/createEstimateCostRowCommand";
import { EditEstimateCostRowCommand } from "./commands/editEstimateCostRowCommand";
import { CreateEstimateSubtotalRowCommand } from "./commands/createEstimateSubtotalRowCommand";
import { EditEstimateSubtotalRowCommand } from "./commands/editEstimateSubtotalRowCommand";
import { EditEstimateRowCommand } from "./commands/editEstimateRowCommand";
import { RemoveEstimateRowCommand } from "./commands/removeEstimateRowCommand";
import { PasteRowCommand } from "./commands/pasteRowCommand";
import { CommandType } from "./commandType";

import { Application } from "./application";
import { ShowContentSearchBarCommand } from "./commands/showContentSearchBarCommand";
import { ShowIndexSearchBarCommand } from "./commands/showIndexSearchBarCommand";
import { ShowBookmarksSearchBarCommand } from "./commands/showBookmarksSearchBarCommand";
import { CutRowCommand } from "./commands/cutRowCommand";
import { CopyRowCommand } from "./commands/copyRowCommand";
import { UndoCommand } from "./commands/undoCommand";
import { RedoCommand } from "./commands/redoCommand";
import { ChooseCostCommand } from "./commands/chooseCostCommand";
import { RemoveEstimateCommand } from "./commands/removeEstimateCommand";
import { RemoveCurrentEstimateCommand } from "./commands/removeCurrentEstimateCommand";
import { RenameEstimateCommand } from "./commands/renameEstimateCommand";
import { RenameCurrentEstimateCommand } from "./commands/renameCurrentEstimateCommand";
import { PrintEstimateCommand } from "./commands/printEstimateCommand";
import { ExportBidCommand } from "./commands/exportBidCommand";

import { AddBookmarkCommand } from "./commands/addBookmarkCommand";
import { RemoveBookmarkCommand } from "./commands/removeBookmarkCommand";

import { LogOutCommand } from "./commands/logOutCommand";
import { ExportInvoiceCommand } from "./commands/exportInvoiceCommand";
import { ShowSearchBarCommand } from "./commands/showSearchBarCommand";
import { ShowEstimateUnitCostsCommand } from "./commands/showEstimateUnitCosts";
import { ShowEstimateDoubleSpaceLinesCommand } from "./commands/showEstimateDoubleSpaceLines";
import { HideEstimateComponentCostsCommand } from "./commands/hideEstimateComponentCosts";

export class CommandsManager {
    public commands: Array<Command> = [];

    constructor(app: Application) {
        this.commands.push(new OpenNewEstimatePopupCommand(app));
        this.commands.push(new OpenEstimatesPopupCommand(app));
        this.commands.push(new OpenCostbooksPopupCommand(app));
        this.commands.push(new OpenCostbookPropertiesPopupCommand(app));
        this.commands.push(new OpenCustomerInfoPopupCommand(app));
        this.commands.push(new OpenCompanyInfoPopupCommand(app));
        this.commands.push(new OpenDefaultCompanyInfoPopupCommand(app));
        this.commands.push(new OpenEstimateSettingsPopupCommand(app));
        this.commands.push(new OpenAccountingSettingsPopupCommand(app));
        this.commands.push(new OpenImportEstimatePopupCommand(app));
        
        this.commands.push(new OpenTaxRatesPopupCommand(app));
        this.commands.push(new OpenMarkupsPopupCommand(app));
        this.commands.push(new OpenPercentagesPopupCommand(app));
        this.commands.push(new OpenAreaCostsModificationsPopupCommand(app));

        this.commands.push(new OpenEstimateSaveAsPopupCommand(app));
        this.commands.push(new OpenEstimateImportPopupCommand(app));
        this.commands.push(new OpenEstimateExportPopupCommand(app));

        this.commands.push(new RenameEstimateCommand(app));
        this.commands.push(new RenameCurrentEstimateCommand(app));
        
        this.commands.push(new RemoveEstimateCommand(app));
        this.commands.push(new RemoveCurrentEstimateCommand(app));

        this.commands.push(new PrintEstimateCommand(app));
        this.commands.push(new ExportBidCommand(app));
        this.commands.push(new ExportInvoiceCommand(app));

        this.commands.push(new CreateEstimateTextRowCommand(app));
        this.commands.push(new EditEstimateTextRowCommand(app));

        this.commands.push(new CreateEstimateCostRowCommand(app));
        this.commands.push(new EditEstimateCostRowCommand(app));

        this.commands.push(new CreateEstimateSubtotalRowCommand(app));
        this.commands.push(new EditEstimateSubtotalRowCommand(app));

        this.commands.push(new EditEstimateRowCommand(app));
        this.commands.push(new RemoveEstimateRowCommand(app));

        this.commands.push(new CutRowCommand(app));
        this.commands.push(new CopyRowCommand(app));
        this.commands.push(new PasteRowCommand(app));
        
        this.commands.push(new UndoCommand(app));
        this.commands.push(new RedoCommand(app));
        
        this.commands.push(new ChooseCostCommand(app));

        this.commands.push(new ShowSearchBarCommand(app));
        this.commands.push(new ShowContentSearchBarCommand(app));
        this.commands.push(new ShowIndexSearchBarCommand(app));
        this.commands.push(new ShowBookmarksSearchBarCommand(app));

        this.commands.push(new AddBookmarkCommand(app));
        this.commands.push(new RemoveBookmarkCommand(app));

        this.commands.push(new LogOutCommand(app));
        
        this.commands.push(new ShowEstimateUnitCostsCommand(app));
        this.commands.push(new ShowEstimateDoubleSpaceLinesCommand(app));
        this.commands.push(new HideEstimateComponentCostsCommand(app));
    }

    execute<T>(type: CommandType, data?: T): JQueryPromise<any> {

        let command = _.find<Command>(this.commands, item => {
            return item.type == type;
        });

        if (!command)
            return $.Deferred().reject().promise();

        return command.execute(data);
    }

    find(type: CommandType): Command | undefined {
        return _.find<Command>(this.commands, item => {
            return item.type == type;
        });
    }
}


// WEBPACK FOOTER //
// ./ClientApp/services/commandsManager.ts